import React, {useEffect} from 'react'
import {connect} from "react-redux";
import {injectIntl} from "react-intl";

import {setSQFTActiveButton, setSQFTMenuOpened} from "../../../../actions/sqftMenuFunctions";
import SlabWorkspace from "../canvas/core/slab/slabWorkspace";
import config from "../canvas/store/sqftConfig";
import {SIDEBAR_NAVIGATION_BUTTONS} from "../../constants";
import {resetEvents} from "../navigation/NavigationHelper";

const SqftSlabWindow = (props) => {
  const {croppedSlabImages, isShowSlabTool, setSQFTActiveButton, setSQFTMenuOpened} = props;

  useEffect(() => {
    // set default menu and reset events
    setSQFTActiveButton(SIDEBAR_NAVIGATION_BUTTONS.move);
    config.workspace.menuItemActive = SIDEBAR_NAVIGATION_BUTTONS.move;
    setSQFTMenuOpened('');
    resetEvents();

    // we launch slab workspace render if at least one slab image from feature exist
    if (croppedSlabImages.length) {
      SlabWorkspace.init();
    }
    SlabWorkspace.setEnabled(true);

    return () => {
      SlabWorkspace.setEnabled(false);
      SlabWorkspace.disableSlabImages();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[isShowSlabTool, setSQFTActiveButton, setSQFTMenuOpened]);

  return (
    <div className={"slab-image__container "} />
  )
};

const mapStateToProps = (store) => ({
  isShowSlabTool: store.sqftSlabState.isShowSlabTool,
  croppedSlabImages: store.sqftSlabState.croppedSlabImages,
});

const mapDispatchToProps = {
  setSQFTActiveButton,
  setSQFTMenuOpened
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftSlabWindow)
)

